/**
 * web-account-pages D1 — an account page signed out: card 2's sign-in step in
 * place, at the same address, as the booked and Pay now pages do. After the
 * Telegram popup the visitor is signed in here and the page draws itself; there
 * is no redirect and no stored return path.
 */
import type { ReactNode } from 'react';

import { useWebSession } from '../../api/session';
import booked from '../../pieces/booked/Booked.module.css';
import { SignInStep } from '../../pieces/sign-in-step';
import shared from '../../styles/shared.module.css';

export function SignedInOnly({ children }: { readonly children: ReactNode }) {
  const status = useWebSession().status;
  if (status === 'signedOut') {
    return (
      <div className={`${shared.wrap} ${booked.signInWrap}`}>
        <SignInStep />
      </div>
    );
  }
  if (status === 'loading') return null;
  return <>{children}</>;
}
